module.exports = new __parcel__URL__("Step_6.60378fae.jpg").toString();